import { Controller } from '@hotwired/stimulus';

export class TimeZoneController extends Controller {
  connect() {
    this.element.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
